import { createSlice } from '@reduxjs/toolkit';
import {
  createConfigSetting,
  fetchAllConfigSettings,
  fetchConfigSettingById,
  updateConfigSetting
} from './configurationSettingsActions';
import { ConfigurationSettingsState } from './configurationSettingsTypes';

const initialState: ConfigurationSettingsState = {
  records: [],
  selectedRecord: undefined,
  loadingStates: {
    create: false,
    fetchAll: false,
    fetchById: false,
    update: false
  },
  errors: {}
};

const configSettingsSlice = createSlice({
  name: 'configurationSettings',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create
      .addCase(createConfigSetting.pending, (state) => {
        state.loadingStates.create = true;
        state.errors.create = undefined;
      })
      .addCase(createConfigSetting.fulfilled, (state, action) => {
        state.loadingStates.create = false;
        state.records.push(action.payload);
      })
      .addCase(createConfigSetting.rejected, (state, action) => {
        state.loadingStates.create = false;
        state.errors.create = action.payload as string;
      })

      // Fetch All
      .addCase(fetchAllConfigSettings.pending, (state) => {
        state.loadingStates.fetchAll = true;
        state.errors.fetchAll = undefined;
      })
      .addCase(fetchAllConfigSettings.fulfilled, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.records = action.payload.data;
      })
      .addCase(fetchAllConfigSettings.rejected, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.errors.fetchAll = action.payload as string;
      })

      // Fetch By ID
      .addCase(fetchConfigSettingById.pending, (state) => {
        state.loadingStates.fetchById = true;
        state.errors.fetchById = undefined;
      })
      .addCase(fetchConfigSettingById.fulfilled, (state, action) => {
        state.loadingStates.fetchById = false;
        state.selectedRecord = action.payload.data;
      })
      .addCase(fetchConfigSettingById.rejected, (state, action) => {
        state.loadingStates.fetchById = false;
        state.errors.fetchById = action.payload as string;
      })

      // Update
      .addCase(updateConfigSetting.pending, (state) => {
        state.loadingStates.update = true;
        state.errors.update = undefined;
      })
      .addCase(updateConfigSetting.fulfilled, (state, action) => {
        state.loadingStates.update = false;
        const index = state.records.findIndex(
          (setting) => setting.id === action.payload.id
        );
        if (index !== -1) {
          state.records[index] = {
            ...action.payload.data,
            id: action.payload.id
          };
        }
      })
      .addCase(updateConfigSetting.rejected, (state, action) => {
        state.loadingStates.update = false;
        state.errors.update = action.payload as string;
      });
  }
});

export default configSettingsSlice.reducer;
